import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { F, th as palette, I, Wordmark } from "@/lib/bricks";
import { navFor, titleFor } from "@/lib/navConfig";
import { useShellDark } from "@/lib/useShellDark";
import { useBookingActionClaimed } from "@/lib/bookingAction";

// Top bar: menu (drawer below 1024), page title, and the account's one booking action.
export default function TopBar({ onOpenSidebar }) {
  const location = useLocation();
  const { user } = useAuth();
  const dark = useShellDark();
  const p = palette(dark);
  const nav = navFor(user);
  const title = titleFor(nav, location.pathname);
  // Desktop has the booking entry in the sidebar. On phones the top bar carries
  // it only when the page has no booking button of its own (one per screen).
  const home = nav.sections[0]?.items[0]?.to;
  const pageHasBook = useBookingActionClaimed();
  const showBook = nav.primary && location.pathname !== home && !pageHasBook;

  return (
    <header
      data-testid="topbar"
      style={{
        minHeight: 64, paddingTop: "env(safe-area-inset-top)", boxSizing: "content-box",
        display: "flex", alignItems: "center", gap: 12,
        borderBottom: `1px solid ${p.hair}`, background: p.bg, fontFamily: F.display, flexShrink: 0,
      }}
      className="px-5 md:px-9"
    >
      <button
        type="button"
        data-testid="open-sidebar-btn"
        aria-label="Open menu"
        onClick={onOpenSidebar}
        className="inline-flex lg:hidden"
        style={{ background: "none", border: "none", cursor: "pointer", width: 44, height: 44, marginLeft: -12, alignItems: "center", justifyContent: "center", padding: 0, flexShrink: 0 }}
      >
        <I name="menu" size={20} color={p.ink2} />
      </button>

      <span className="sm:hidden"><Wordmark size={15} color={p.ink} /></span>
      {title && (
        <div className="hidden sm:block" style={{ fontSize: 14, fontWeight: 500, color: p.ink, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", minWidth: 0 }}>
          {title}
        </div>
      )}

      {showBook && (
        <a
          className="inline-flex lg:hidden"
          href={nav.primary.href}
          data-testid="topbar-book"
          style={{
            marginLeft: "auto", minHeight: 44, padding: "0 16px", alignItems: "center", gap: 8,
            border: `1px solid ${dark ? "#5E574C" : "#97928A"}`, borderRadius: 2, color: p.ink, textDecoration: "none",
            fontSize: 13, fontWeight: 500, whiteSpace: "nowrap", flexShrink: 0,
          }}
        >
          <I name="booked" size={16} color={p.ink} />{nav.primary.label}
        </a>
      )}
    </header>
  );
}
